module.exports = __webpack_public_path__ + "static/media/display_red.712fcdf2.png";